import {type ReactNode, type ComponentType, type KeyboardEvent} from 'react';

import classnames from 'classnames';

import {CloseButton} from 'shells/button/close-button/close-button';
import type {RealAndFakeWidgetType} from 'shells/widgets/types';

import {CardWidgetHeader} from '../card-widget/card-widget-header';

import styles from './card-widget-banner.module.css';

import cardWidgetStyles from '../card-widget/card-widget.module.css';

interface Props {
    title: string;
    secondaryTitle?: ReactNode;
    titleIcon: ComponentType<any>;
    actionLabel: string;
    onClick: () => void;
    onDismiss: () => void;
    widgetType: RealAndFakeWidgetType;
}

export function CardWidgetBanner(props: Props) {
    const handleClickTargetKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
        if (e.target !== e.currentTarget) {
            return;
        }
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            props.onClick();
        }
    };

    const isNutshellIqBanner = props.widgetType === 'NUTSHELL_IQ';

    return (
        <div
            className={classnames(
                styles['banner-root'],
                'flex align-center justify-sb background-white br-8 full-width border-box pr-8',
                cardWidgetStyles['card-widget--bordered'],
                isNutshellIqBanner && cardWidgetStyles['card-widget--ai-variant']
            )}
        >
            <div
                role='button'
                tabIndex={0}
                onClick={props.onClick}
                onKeyDown={handleClickTargetKeyDown}
                aria-label={`${props.title} — ${props.actionLabel}`}
                className={classnames(
                    styles['banner-click-target'],
                    'pointer-cursor flex-grow min-width-0'
                )}
            >
                <CardWidgetHeader
                    title={props.title.toUpperCase()}
                    titleIcon={props.titleIcon}
                    isCollapsible={false}
                    isCollapsed={false}
                    onToggleCollapse={() => {}}
                    secondaryTitle={props.secondaryTitle}
                    secondaryTitleClickPropagates
                    addButtonProps={{
                        variant: 'singular',
                        onClick: props.onClick,
                        label: props.actionLabel,
                    }}
                    type={props.widgetType}
                />
            </div>
            <div className='mt-2'>
                <CloseButton
                    onClick={props.onDismiss}
                    tooltip='Dismiss'
                    size={11}
                    variant='darkest'
                    alignCenter={true}
                />
            </div>
        </div>
    );
}
